const baseModel = {
  path: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/ss3/tileset.json`,
  adjustHeight: -37,
};



export default baseModel;
